import request from "@/utils/request.js";

export function getCsChatParams() {
	return request.get('cs/chat-params', {}, { noRedirect: true });
}

export function getCsAgentParams() {
	return request.get('cs/agent-params', {}, { noRedirect: true });
}

export function markCsRead() {
	return request.post('cs/mark-cs-read', {}, { noRedirect: true });
}
